import { inject, Service } from '@angular/core';
import { AnalyticsService } from '@app/core/services/mixpanel/analytics.service';

export interface IMillerColumnTrackingContext {
  feature: string;
}

@Service()
export class Ag1MillerColumnMixpanelEventTrackingService {
  private _analyticsService = inject(AnalyticsService);

  trackTopLevelSelected(context: IMillerColumnTrackingContext): void {
    this._analyticsService.track('Miller column: top level selected', {
      feature: context.feature,
    });
  }

  trackSubLevelSelected(context: IMillerColumnTrackingContext): void {
    this._analyticsService.track('Miller column: sub level selected', {
      feature: context.feature,
    });
  }

  trackCollapseColumn(context: IMillerColumnTrackingContext): void {
    this._analyticsService.track('Miller column: collapse column', {
      feature: context.feature,
    });
  }
}
